export { platform, Platform } from './platform';
